export default __webpack_public_path__ + "static/media/rummo-for-business_2.f4528bfb.svg";